import type { DocCardData } from './types';

/**
 * Read-only doc result card. The whole card is clickable → onOpen(), which
 * navigates to the Drive module and selects the doc (no modal).
 */
export function DocResultCard({ data, onOpen }: { data: DocCardData; onOpen: () => void }) {
  const { title, bodyPreview } = data;

  return (
    <button type="button" className="rc-card rc-doc" onClick={onOpen}>
      <div className="rc-meta">
        <span className="rc-meta-kind">📄 DOC</span>
      </div>

      <div className="rc-subject">{title || 'Untitled doc'}</div>
      {bodyPreview && <div className="rc-note-preview">{bodyPreview}</div>}
    </button>
  );
}
